/**
 * Build a WhatsApp Click-to-Chat URL for the InterQuest conductor.
 *
 * Usage:
 *   whatsappUrl({ orderRef: "ABC12345" })
 *   whatsappUrl({ schoolName: "Highgate School" })
 *
 * Falls back to a sensible default message when no context is supplied.
 */
const CONDUCTOR_NUMBER = process.env.REACT_APP_CONDUCTOR_WHATSAPP || "353852181004";

const buildText = ({ orderRef, schoolName, custom } = {}) => {
  if (custom) return custom;
  if (orderRef) {
    return `Hi InterQuest — I'm travelling on booking #${orderRef} and could use a hand.`;
  }
  if (schoolName) {
    return `Hi InterQuest — I'm enquiring on behalf of ${schoolName} about a school trip and would like to chat.`;
  }
  return "Hi InterQuest — could you help me with my trip?";
};

export const whatsappUrl = (ctx = {}) => {
  const text = buildText(ctx);
  return `https://wa.me/${CONDUCTOR_NUMBER}?text=${encodeURIComponent(text)}`;
};

export const conductorNumber = CONDUCTOR_NUMBER;
